<div class="grid place-items-center h-screen bg-gray-100">
  <p-card class="w-96">
    <img
      src="assets/planify-logo-text-gray.svg"
      alt="Logo"
      class="m-auto"
      class="planify-logo"
    />
    <!-- Formulaire classique -->
    <form
      [formGroup]="loginForm"
      (ngSubmit)="loginClassic()"
      class="flex flex-col gap-4 p-4"
    >
      <div class="form-group">
        <label for="email" class="block text-sm font-medium text-gray-700"
          >Email</label
        >
        <input
          id="email"
          type="text"
          pInputText
          formControlName="email"
          class="w-full p-2 border border-gray-300 rounded"
        />
      </div>
      <div class="form-group">
        <label for="password" class="block text-sm font-medium text-gray-700"
          >Mot de passe</label
        >
        <p-password
          id="password"
          type="password"
          formControlName="password"
          [feedback]="false"
          [toggleMask]="true"
          [style]="{ width: '100%' }"
          inputStyleClass="w-full p-2 border border-gray-300 rounded"
        ></p-password>
      </div>
      <div class="form-group">
        <p-button
          [disabled]="loginForm.invalid"
          [loading]="isLoadingClassic()"
          type="submit"
          label="Se connecter"
          [style]="{ width: '100%' }"
        ></p-button>
      </div>
    </form>

    <div class="flex flex-col items-center gap-4 p-4 border-t mt-4">
      <span class="text-sm text-gray-500">Ou se connecter avec</span>
      <!-- Bouton personnalisé pour Microsoft avec logo -->
      <button
        pButton
        type="button"
        class="microsoft-login-btn w-full flex items-center justify-center"
        (click)="loginWithMicrosoft()"
      >
        <img
          src="assets/microsoft-logo.svg"
          alt="Microsoft Logo"
          class="microsoft-logo mr-2"
        />
        <span>Se connecter avec Microsoft</span>
      </button>
    </div>
  </p-card>
</div>
